import * as tslib_1 from "tslib";
import { PerspectiveProjection, CoordinateSystem } from "@awayjs/core";
import { DefaultRenderer } from "@awayjs/renderer";
import { BitmapImage2D } from "@awayjs/graphics";
import { Scene, DisplayObject, DisplayObjectContainer } from "@awayjs/scene";
import { SceneGraphPartition } from "../partition/SceneGraphPartition";
import { View } from "../View";
/**
 *
 */
var ViewImage2D = (function (_super) {
    tslib_1.__extends(ViewImage2D, _super);
    /**
     * Creates a BitmapImage2D object with a specified width and height. If you
     * specify a value for the <code>fillColor</code> parameter, every pixel in
     * the bitmap is set to that color.
     *
     * <p>By default, the bitmap is created as transparent, unless you pass
     * the value <code>false</code> for the transparent parameter. After you
     * create an opaque bitmap, you cannot change it to a transparent bitmap.
     * Every pixel in an opaque bitmap uses only 24 bits of color channel
     * information. If you define the bitmap as transparent, every pixel uses 32
     * bits of color channel information, including an alpha transparency
     * channel.</p>
     *
     * @param width       The width of the bitmap image in pixels.
     * @param height      The height of the bitmap image in pixels.
     * @param transparent Specifies whether the bitmap image supports per-pixel
     *                    transparency. The default value is <code>true</code>
     *                    (transparent). To create a fully transparent bitmap,
     *                    set the value of the <code>transparent</code>
     *                    parameter to <code>true</code> and the value of the
     *                    <code>fillColor</code> parameter to 0x00000000(or to
     *                    0). Setting the <code>transparent</code> property to
     *                    <code>false</code> can result in minor improvements
     *                    in rendering performance.
     * @param fillColor   A 32-bit ARGB color value that you use to fill the
     *                    bitmap image area. The default value is
     *                    0xFFFFFFFF(solid white).
     */
    function ViewImage2D(width, height, transparent, fillColor, powerOfTwo, stage) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = 0xffffffff; }
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        if (stage === void 0) { stage = null; }
        var _this = _super.call(this, width, height, transparent, fillColor, powerOfTwo) || this;
        _this._fillColor = fillColor;
        _this._stage = stage;
        return _this;
    }
    Object.defineProperty(ViewImage2D.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return ViewImage2D.assetType;
        },
        enumerable: true,
        configurable: true
    });
    ViewImage2D.prototype.createView = function () {
        //create the view
        this._view = new View(new DefaultRenderer(this._stage));
        this._view.disableMouseEvents = true;
        this._view.width = this._rect.width;
        this._view.height = this._rect.height;
        this._fillColor = this._fillColor;
        this._view.backgroundAlpha = this._transparent ? (this._fillColor & 0xff000000) >>> 24 : 1;
        this._view.backgroundColor = this._fillColor & 0xffffff;
        this._view.renderer.renderableSorter = null; //new RenderableSort2D();
        //create the projection
        var projection = new PerspectiveProjection();
        projection.coordinateSystem = CoordinateSystem.RIGHT_HANDED;
        projection.originX = 0;
        projection.originY = 0;
        projection.preserveFocalLength = true;
        projection.setViewRect(0, 0, this._rect.width, this._rect.height);
        projection.setStageRect(0, 0, this._rect.width, this._rect.height);
        this._view.camera.projection = projection;
    };
    /**
     * Frees memory that is used to store the BitmapImage2D object.
     *
     * <p>When the <code>dispose()</code> method is called on an image, the width
     * and height of the image are set to 0. All subsequent calls to methods or
     * properties of this BitmapImage2D instance fail, and an exception is thrown.
     * </p>
     *
     * <p><code>BitmapImage2D.dispose()</code> releases the memory occupied by the
     * actual bitmap data, immediately(a bitmap can consume up to 64 MB of
     * memory). After using <code>BitmapImage2D.dispose()</code>, the BitmapImage2D
     * object is no longer usable and an exception may be thrown if
     * you call functions on the BitmapImage2D object. However,
     * <code>BitmapImage2D.dispose()</code> does not garbage collect the BitmapImage2D
     * object(approximately 128 bytes); the memory occupied by the actual
     * BitmapImage2D object is released at the time the BitmapImage2D object is
     * collected by the garbage collector.</p>
     *
     */
    ViewImage2D.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        //todo
    };
    ViewImage2D.prototype.draw = function (source, matrix, colorTransform, blendMode, clipRect, smoothing) {
        if (source instanceof DisplayObject) {
            var root = new DisplayObjectContainer();
            root.addChild(source);
            if (matrix) {
                root.transform.scaleTo(matrix.a, -matrix.d, 1);
                root.transform.moveTo(matrix.tx, matrix.ty, 0);
            }
            root.transform.colorTransform = colorTransform;
            if (!this._view)
                this.createView();
            this._view.scene = new Scene();
            this._view.scene.addChild(root);
            this._view.setPartition(root, new SceneGraphPartition(root));
            //save snapshot if unlocked
            if (!this._locked)
                this._view.renderer.queueSnapshot(this);
            this._view.renderer.disableClear = !this._locked;
            //render
            this._view.renderer._iRender(this._view.camera.projection, this._view, this);
            return;
        }
        _super.prototype.draw.call(this, source, matrix, colorTransform, blendMode, clipRect, smoothing);
    };
    /**
     *
     * @param width
     * @param height
     * @private
     */
    ViewImage2D.prototype._setSize = function (width, height) {
        _super.prototype._setSize.call(this, width, height);
        if (this._view) {
            this._view.width = this._rect.width;
            this._view.height = this._rect.height;
            this._view.camera.projection.setViewRect(0, 0, this._rect.width, this._rect.height);
            this._view.camera.projection.setStageRect(0, 0, this._rect.width, this._rect.height);
        }
    };
    return ViewImage2D;
}(BitmapImage2D));
export { ViewImage2D };
ViewImage2D.assetType = "[image ViewImage2D]";



// WEBPACK FOOTER //
// ../dist/lib/image/ViewImage2D.js